import { render, staticRenderFns } from "./orgZbDrawer.vue?vue&type=template&id=2059928e&scoped=true&"
import script from "./orgZbDrawer.vue?vue&type=script&lang=js&"
export * from "./orgZbDrawer.vue?vue&type=script&lang=js&"
import style0 from "./orgZbDrawer.vue?vue&type=style&index=0&id=2059928e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059928e",
  null
  
)

export default component.exports